import React, { memo, useCallback, useEffect, useState } from "react";
import { Spinner, Text } from "@chakra-ui/react";
import colors from "app/colors";
import { IMAGE_GALLERY_ITEM_MAX_HEIGHT } from "modules/utils/Constants";

interface IProps {
  fileUrl?: string | null;
}

const FileTextViewer = ({ fileUrl }: IProps) => {
  const [contents, setContents] = useState<string>();

  const fetchContents = useCallback(async () => {
    if (!fileUrl) return;
    const response = await fetch(fileUrl, {
      method: "GET",
      credentials: "include",
    });
    const text = await response.text();
    setContents(text);
  }, [fileUrl]);

  useEffect(() => {
    fetchContents();
  }, [fetchContents]);

  if (!fileUrl || !contents) {
    return <Spinner />;
  }

  return (
    <Text
      display="flex"
      flexDirection="column"
      h="full"
      w="calc(100vw - 160px)"
      maxH={IMAGE_GALLERY_ITEM_MAX_HEIGHT}
      overflowY="auto"
      whiteSpace="pre-wrap"
      color={colors.white}
      p={4}
    >
      {contents}
    </Text>
  );
};

export default memo(FileTextViewer);
